import type { ContactTranslations } from './translations.types'

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends (...args: infer A) => infer R
    ? (...args: A) => R
    : T[K] extends object
      ? DeepPartial<T[K]>
      : T[K]
}

export type PartialTranslations = DeepPartial<ContactTranslations>

export function mergeTranslations(
  defaults: ContactTranslations,
  overrides?: PartialTranslations,
): ContactTranslations {
  if (!overrides) return defaults

  function deepMerge(
    base: Record<string, unknown>,
    partial: Record<string, unknown>,
  ): Record<string, unknown> {
    const result: Record<string, unknown> = { ...base }
    for (const key of Object.keys(partial)) {
      const override = partial[key]
      if (override === undefined) continue
      const baseVal = base[key]
      if (typeof override === 'function' || typeof baseVal !== 'object' || baseVal === null) {
        result[key] = override
      } else {
        result[key] = deepMerge(
          baseVal as Record<string, unknown>,
          override as Record<string, unknown>,
        )
      }
    }
    return result
  }

  return deepMerge(
    defaults as unknown as Record<string, unknown>,
    overrides as unknown as Record<string, unknown>,
  ) as unknown as ContactTranslations
}
